/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseDocument } from './CaseDocument';
import { Icd10Code } from './Icd10Code';
import type { LabStation } from './LabStation';

export type Specimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    /**
     * Final gross description
     */
    gross_description?: string | null;
    materials_received?: string | null;
    procedure?: Specimen.procedure | null;
    site?: string | null;
    source?: string | null;
    /**
     * what is the source for the specimen
     */
    type?: Specimen.type | null;
    /**
     * Changing clinical history may also change protocols
     */
    clinical_history?: string | null;
    biopsy_type?: Specimen.biopsy_type;
    readonly diagnosis_category?: string;
    /**
     * Changing this value will ALSO modify the received_date for the case.
     */
    received_date?: string | null;
    /**
     * Changing this value will ALSO modify the collected_date for the case.
     */
    collected_date?: string | null;
    readonly lab_station?: LabStation;
    readonly case_documents?: Array<CaseDocument>;
    lis_state?: Specimen.lis_state | null;
    /**
     * Token selections for Grossing Mad-Lib
     */
    grossing_token_selections?: any;
    /**
     * Modifier selections for Grossing Mad-Lib
     */
    grossing_modifier_selections?: any;
    /**
     * Using text editing instead of Grossing Mad-Lib?
     */
    grossing_raw_text?: boolean;
    readonly case_id?: number;
    readonly slow_mohs_source_id?: number;
    protocols?: Array<'dif' | 'alopecia' | 'whole_specimen' | 'nail' | 'pash_reflex' | 'pasf_reflex' | 'slow_mohs'>;
    /**
     * LabStain selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_stain_selections?: Array<number> | null;
    /**
     * LabPanel selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_panel_selections?: Array<number> | null;
    readonly glass_read?: boolean;
    readonly icd10codes?: Array<Icd10Code>;
}

export namespace Specimen {

    export enum procedure {
        C = 'c',
        E = 'e',
        PE = 'pe',
        IB = 'ib',
        NC = 'nc',
        NA = 'na',
        PB = 'pb',
        SB = 'sb',
        SBD = 'sbd',
        SCE = 'sce',
        SR = 'sr',
        SRD = 'srd',
        SNB = 'snb',
        GR = 'gr',
        SE = 'se',
        EBX = 'ebx',
        FB = 'fb',
        MOHS = 'mohs',
        DBLK = 'dblk',
        U = 'u',
        O = 'o',
    }

    /**
     * what is the source for the specimen
     */
    export enum type {
        MUCOSA = 'MUCOSA',
        SKIN = 'SKIN',
        NAIL = 'NAIL',
        SOFT_TISSUE = 'SOFT TISSUE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }

    export enum biopsy_type {
        PUNCH = 'PUNCH',
        SHAVE = 'SHAVE',
        EXCISION = 'EXCISION',
        UNKNOWN = 'UNKNOWN',
    }

    export enum lis_state {
        BOTTLED = 'bottled',
        RECEIVED = 'received',
        GROSSED = 'grossed',
    }


}
